import React from "react";
import { useRouter, withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { CTAContainer, ContentContainer, EndingPhrase, ImageContainer, SubTitle, SuccessContainer, SuccessImage, Title, TitleContainer } from "./Success.styles";
import Logo from '../../../../../public/images/logo-new.svg';
import { Button, List } from "../../../../components";
import { ListArray } from "./Success.content";
import Image from "next/image";

interface SuccessProps extends WithRouterProps {
  firstName: string | undefined;
  bookingInterestId: number | undefined | null;
}

const Success: React.FC<SuccessProps> = ({
  firstName,
  bookingInterestId,
}) => {
  const router = useRouter();

  const redirectToAddSession = () => {
    router.reload()
  };

  return (
    <SuccessContainer
      data-cy="booking-interest-registration-success"
      data-bookinginterest-id={bookingInterestId}>
      <TitleContainer>
        <SuccessImage>
          <Logo />
        </SuccessImage>
        <Title>
          You’re on the List for Tickets {firstName}!
        </Title>
      </TitleContainer>
      <ContentContainer>
        <SubTitle>
          So, What Happens Now?
        </SubTitle>
        <ImageContainer>
          <Image src="/images/email/progress-red-carpet-application.png" fill alt="Progress bar - applied for tickets step" />
        </ImageContainer>
        <List elements={ListArray} />
      </ContentContainer>
      <CTAContainer>
        <EndingPhrase>
          Want to increase your chances of getting tickets?
        </EndingPhrase>
        <Button onClick={() => router.reload()} data-cy="book-another-ticket-button"> Apply for another Session </Button>
      </CTAContainer>
    </SuccessContainer>
  );
};

export default withRouter(Success);
